import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocViewer from "@cyntler/react-doc-viewer";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: 1000,
  height: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  display: "flex",
  flexDirection: "column",
  outline: "none",
};

export default function DocumentModelBox({
  open,
  handleClose,
  image_url,
  type,
  previewDoc,
}) {
  const docs = [{ uri: image_url }];
  const fileExtension = image_url?.split(".").pop().toLowerCase();
  const isOfficeDoc = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
    fileExtension || ""
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
    >
      <Box sx={style} mb={4}>
        <IconButton
          onClick={handleClose}
          sx={{
            alignSelf: "flex-end",
            margin: 1,
            position: "absolute",
            top: -5,
            right: 8,
            backgroundColor: "navy",
            fontSize: "10px",
            padding: "3px !important",
            "&:hover": {
              backgroundColor: "navy", // keep same
            },
          }}
          aria-label="close"
        >
          <CloseIcon style={{ color: "white" }} fontSize="small" />
        </IconButton>

        {/* Image Preview */}
        {type === "image" && image_url && (
          <Box
            component="img"
            src={image_url}
            alt="Preview"
            sx={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
              marginTop: 4,
              flexGrow: 1,
            }}
            onContextMenu={(e) => e.preventDefault()}
          />
        )}

        {/* PDF or Other Document Viewer */}
        {type !== "image" && (
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              mt: 4,
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {type === "pdf" ? (
              <iframe
                className="iframe-content"
                src={image_url}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={{ border: "none", flex: 1 }}
              />
            ) : isOfficeDoc ? (
              <iframe
                className="iframe-content"
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                  image_url
                )}`}
                title="Office Document Viewer"
                width="100%"
                height="100%"
                style={{ border: "none", flex: 1 }}
              />
            ) : (
              <Box sx={{ width: "100%", height: "100%", overflow: "auto" }}>
                <DocViewer
                  documents={docs}
                  config={{ header: { disableHeader: true } }}
                  style={{
                    width: "100%",
                    minWidth: "fit-content",
                    height: "100%",
                    flex: 1,
                  }}
                />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
}
